import {
  BaseRouterStoreState,
  ROUTER_CANCEL,
  ROUTER_ERROR,
  ROUTER_NAVIGATION,
  RouterAction,
  SerializedRouterStateSnapshot
} from '@ngrx/router-store';
import { Action } from '@ngrx/store';

export interface RouterReducerState<T extends BaseRouterStoreState = SerializedRouterStateSnapshot> {
  prevState: T | undefined;
  state: T;
  navigationId: number;
}

export function routerReducer<RouterState extends BaseRouterStoreState = SerializedRouterStateSnapshot>(
  state: RouterReducerState<RouterState> | undefined,
  action: Action
): RouterReducerState<RouterState> {
  // Allow compilation with strictFunctionTypes - ref: #1344
  const routerAction = action as RouterAction<any, RouterState>;
  switch (routerAction.type) {
    case ROUTER_NAVIGATION:
    case ROUTER_ERROR:
    case ROUTER_CANCEL:
      return {
        prevState: state?.state,
        state: routerAction.payload.routerState,
        navigationId: routerAction.payload.event.id
      };
    default:
      return state;
  }
}
